module.exports = __webpack_public_path__ + "img/swiper_right_img.2378f287.png";